/* eslint-disable */

export const valueSchema = {
  type: 'object',
  properties: {
    value: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          key: {
            type: 'string',
            enum: [
              'HOUSING_DORMITORIES_ARE_NOT_SEPARATE_FROM_THE_PRODUCTION_AND_WA',
              'HOUSING_DORMITORIES_ARE_NOT_CLEAN',
              'HOUSING_DORMITORIES_MINIMUM_SPACE_DIMENSIONS_ARE_OUT_OF_LINE_WI',
              'BEDS_ARE_ARRANGED_MORE_THAN_TWO_TIERS_HIGH',
              'HOUSING_DORMITORIES_ARE_NOT_LIT_IN_LINE_WITH_LEGAL_REQUIREMENTS',
              'HOUSING_DORMITORIES_ARE_NOT_VENTILATED_IN_LINE_WITH_LEGAL_REQUI',
              'HOUSING_DORMITORIES_PROTECTION_AGAINST_HEAT_COLD_AND_DAMPNESS_I',
              'HOUSING_DORMITORIES_NOISE_PROTECTION_IS_OUT_OF_LINE_WITH_LEGAL_',
              'HOUSING_DORMITORIES_PROTECTION_AGAINST_DISEASE_CARRYING_ANIMALS',
              'HOUSING_DORMITORIES_COOKING_AND_STORAGE_FACILITIES_ARE_OUT_OF_L',
              'HOUSING_DORMITORIES_OFFER_WORKERS_ADEQUATE_PRIVACY',
              'HOUSING_DORMITORIES_ACCESS_TO_FREE_AND_POTABLE_WATER_IS_OUT_OF_',
              'HOUSING_DORMITORIES_DO_NOT_HAVE_LEGALLY_REQUIRED_TOILETS_SHOWER',
              'HOUSING_DORMITORIES_PROTECTION_FROM_FIRE_IS_OUT_OF_LINE_WITH_LE',
              'HOUSING_DORMITORIES_EMERGENCY_PREPAREDNESS_IS_OUT_OF_LINE_WITH_',
              'NONE_OF_THE_ABOVE_THE_FACILITY_IS_MEETING_ALL_MEASURES_LISTED_R',
              'DOES_HOUSING_DORMITORIES_PROVIDE_PROVISIONS_FOR_PREGNANT_AND_NU',
              'DOES_HOUSING_DORMITORIES_HAVE_TRAINED_SECURITY_PERSONNEL_',
              'DOES_HOUSING_DORMITORIES_OFFER_SUFFICIENT_STORAGE_SPACE_FOR_WOR',
              'ARE_HOUSING_DORMITORIES_IN_LINE_WITH_ALL_OTHER_HEALTH_AND_SAFET',
              'ARE_BUILDING_CONSTRUCTION_STRUCTURAL_SAFETY_AND_FIRE_PERMITS_AN',
              'ARE_ONSITE_CANTEENS_IN_LINE_WITH_LEGAL_REQUIREMENTS_',
              'ARE_OFF_SITE_CANTEENS_MANAGED_BY_THE_FACILITY_IN_LINE_WITH_LEGA',
            ],
          },
          isChecked: {
            type: 'boolean',
          },
          followUp: {
            type: ['object', 'null'],
            properties: {
              value: {
                type: 'string',
              },
            },
            required: ['value'],
          },
        },
        required: ['key', 'isChecked', 'followUp'],
      },
    },
  },
  required: ['value'],
}

export const validationSchema = {
  type: 'array',
  minItems: 1,
  items: {
    type: 'object',
    required: ['id', 'name'],
    additionalProperties: true,
    properties: {
      id: {type: 'string', minLength: 1},
      name: {type: 'string', minLength: 1},
    },
  },
}

export const answerSchema = {
  type: 'object',
  additionalProperties: false,
  properties: {
    is_the_fac_failing_to_implement_measures_regarding_housingdormi: valueSchema,
  },
}
